"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFormatChars = exports.CONTROLLED_PROPS = void 0;
var CONTROLLED_PROPS = ['disabled', 'onBlur', 'onChange', 'onFocus', 'onMouseDown', 'readOnly', 'value'];
exports.CONTROLLED_PROPS = CONTROLLED_PROPS;
var defaultFormatChars = {
  '#': /[0-9]/,
  '9': /[0-9]/,
  a: /[A-Za-z]/,
  x: /[A-Za-z]/,
  '*': /[A-Za-z0-9]/
};
exports.defaultFormatChars = defaultFormatChars;